import styled from "styled-components";

export const ApproveActivityEditAnswerFormStyled = styled.div`
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  min-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .question_item {
    text-align: left;
    color: ${({ theme }) => theme.COLORS.BLACK_1};
  }
  .ans_block {
    margin-bottom: 8px;
    display: flex;
    column-gap: 10px;
    .ans_label {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
    .ans_value {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
  }
  .action_row {
    margin-top: 8px;
    display: flex;
    justify-content: flex-end;
    column-gap: 12px;
    .btn_wrap {
      min-width: 120px;
    }
  }
`;
